import React from 'react';
import { ScrollReveal } from '../components/ScrollReveal';
import { Check } from 'lucide-react';
export function ProductRevealSection() {
  return <section id="midnight-magnet" className="bg-gradient-to-b from-cosmic-deep to-cosmic-black relative z-10 py-12 px-6 border-t border-violet/20" data-id="element-180">
      <ScrollReveal className="max-w-5xl mx-auto flex flex-col items-center" data-id="element-181">
        <p className="text-gold uppercase tracking-widest text-sm font-semibold mb-4" data-id="element-182">
          Introducing
        </p>

        <h2 className="font-playfair text-lunar-white text-5xl md:text-7xl font-bold leading-tight mb-4 text-center text-glow-violet" data-id="element-183">
          The Midnight Magnet
        </h2>

        <p className="text-lunar-lavender text-xl md:text-2xl text-center max-w-2xl mb-16 font-lato" data-id="element-184">
          The 3-Minute Sleep Script to Manifest Your Specific Person — Starting
          Tonight
        </p>

        <div className="flex flex-col lg:flex-row items-center gap-12 w-full" data-id="element-185">
          {/* Mockup Side */}
          <div className="w-full lg:w-1/2 flex justify-center" data-id="element-186">
            <div className="relative w-full max-w-sm aspect-[3/4] bg-cosmic-card rounded-2xl border border-gold/30 shadow-[0_0_40px_rgba(123,47,190,0.3)] overflow-hidden flex flex-col items-center justify-center p-8" data-id="element-187">
              <div className="absolute inset-0 bg-gradient-to-br from-violet/20 to-transparent" data-id="element-188"></div>
              <div className="relative z-10 flex flex-col items-center text-center" data-id="element-189">
                <div className="w-20 h-20 mb-6 rounded-full border border-gold flex items-center justify-center bg-cosmic-dark" data-id="element-190">
                  <span className="text-gold text-3xl" data-id="element-191">☽</span>
                </div>
                <h3 className="font-playfair text-gold text-2xl font-bold mb-2" data-id="element-192">
                  The Midnight Magnet
                </h3>
                <p className="text-lunar-lavender text-sm font-fell italic" data-id="element-193">
                  Sacred Sleep Scripts
                </p>
                <div className="mt-12 w-32 h-1 bg-gold/30 rounded-full" data-id="element-194"></div>
                <div className="mt-4 w-24 h-1 bg-gold/20 rounded-full" data-id="element-195"></div>
              </div>
            </div>
          </div>

          {/* Features Side */}
          <div className="w-full lg:w-1/2" data-id="element-196">
            <h3 className="text-2xl font-playfair text-lunar-white font-bold mb-8" data-id="element-197">
              What's Inside:
            </h3>

            <ul className="space-y-6" data-id="element-198">
              <li className="flex items-start" data-id="element-199">
                <div className="mt-1 mr-4 text-gold flex-shrink-0" data-id="element-200">✦</div>
                <div data-id="element-201">
                  <h4 className="text-lunar-white font-bold text-lg mb-1" data-id="element-202">
                    The Core "Specific Person" Manifestation Script
                  </h4>
                  <p className="text-lunar-muted text-sm leading-relaxed" data-id="element-203">
                    Read it in 3 minutes before sleep — works night one to align
                    your frequency.
                  </p>
                </div>
              </li>

              <li className="flex items-start" data-id="element-204">
                <div className="mt-1 mr-4 text-gold flex-shrink-0" data-id="element-205">✦</div>
                <div data-id="element-206">
                  <h4 className="text-lunar-white font-bold text-lg mb-1" data-id="element-207">
                    The Heart-Opening Cord Release Script
                  </h4>
                  <p className="text-lunar-muted text-sm leading-relaxed" data-id="element-208">
                    Clear old emotional blocks that keep you attracting the
                    wrong men.
                  </p>
                </div>
              </li>

              <li className="flex items-start" data-id="element-209">
                <div className="mt-1 mr-4 text-gold flex-shrink-0" data-id="element-210">✦</div>
                <div data-id="element-211">
                  <h4 className="text-lunar-white font-bold text-lg mb-1" data-id="element-212">
                    The Magnetic Worthiness Affirmation Protocol
                  </h4>
                  <p className="text-lunar-muted text-sm leading-relaxed" data-id="element-213">
                    Reprogram deep "I don't deserve love" beliefs while you
                    sleep.
                  </p>
                </div>
              </li>

              <li className="flex items-start" data-id="element-214">
                <div className="mt-1 mr-4 text-gold flex-shrink-0" data-id="element-215">✦</div>
                <div data-id="element-216">
                  <h4 className="text-lunar-white font-bold text-lg mb-1" data-id="element-217">
                    The 21-Night Manifestation Tracker
                  </h4>
                  <p className="text-lunar-muted text-sm leading-relaxed" data-id="element-218">
                    Simple daily check-in to track shifts in your energy and
                    reality.
                  </p>
                </div>
              </li>

              <li className="flex items-start bg-violet/10 p-4 rounded-lg border border-violet/30" data-id="element-219">
                <div className="mt-1 mr-4 text-electric flex-shrink-0" data-id="element-220">✦</div>
                <div data-id="element-221">
                  <h4 className="text-electric font-bold text-lg mb-1" data-id="element-222">
                    BONUS: The 5-Minute Emergency Heart Script
                  </h4>
                  <p className="text-lunar-lavender text-sm leading-relaxed" data-id="element-223">
                    For the nights when the loneliness hits hardest and you need
                    immediate peace.
                  </p>
                </div>
              </li>
            </ul>

            <div className="mt-10 p-6 bg-cosmic-card border border-gold/40 rounded-xl text-center" data-id="element-224">
              <p className="text-lunar-muted line-through text-lg mb-1" data-id="element-225">
                Total Value: $47.00
              </p>
              <p className="text-gold font-playfair text-3xl font-bold" data-id="element-226">
                Today Only: $6.37
              </p>
            </div>
          </div>
        </div>
      </ScrollReveal>
    </section>;
}